export class ChatContainer {
  private container: HTMLElement;
  private messagesContainer: HTMLElement;

  constructor(parentElement: HTMLElement) {
    this.container = document.createElement('div');
    this.container.className = 'chat-container';
    this.container.id = 'chat-messages';

    this.messagesContainer = this.container;
    parentElement.appendChild(this.container);
  }

  addMessage(content: string, type: 'bot' | 'user'): HTMLElement {
    const message = document.createElement('div');
    message.className = `message ${type}`;

    const bubble = document.createElement('div');
    bubble.className = 'message-bubble';
    bubble.textContent = content;

    message.appendChild(bubble);
    this.messagesContainer.appendChild(message);

    this.scrollToBottom();
    return message;
  }

  addBotMessage(content: string): HTMLElement {
    return this.addMessage(content, 'bot');
  }

  addUserMessage(content: string): HTMLElement {
    return this.addMessage(content, 'user');
  }

  addTypingIndicator(): HTMLElement {
    const message = document.createElement('div');
    message.className = 'message bot';
    message.id = 'typing-indicator';

    const bubble = document.createElement('div');
    bubble.className = 'message-bubble typing-indicator';
    bubble.innerHTML = '<span></span><span></span><span></span>';

    message.appendChild(bubble);
    this.messagesContainer.appendChild(message);

    this.scrollToBottom();
    return message;
  }

  removeTypingIndicator(): void {
    const indicator = document.getElementById('typing-indicator');
    if (indicator) {
      indicator.remove();
    }
  }

  scrollToBottom(): void {
    // Use setTimeout to ensure DOM is updated before scrolling
    setTimeout(() => {
      this.container.scrollTop = this.container.scrollHeight;
    }, 50);
  }

  // Force immediate scroll without delay
  scrollToBottomImmediate(): void {
    this.container.scrollTop = this.container.scrollHeight;
  }

  clear(): void {
    this.messagesContainer.innerHTML = '';
  }

  getElement(): HTMLElement {
    return this.container;
  }
}
